'use client';

import { useFaqExpandState } from '@/components/blocks/cms/Faq/FaqExpandProvider';

export function FaqExpandToggle() {
    const { hasMore, showButton, handleShowMore } = useFaqExpandState();

    if (!showButton) {
        return null;
    }

    return (
        <div className="flex justify-center pt-10">
            <button className="btn btn-primary px-[30px] py-6" type="submit" onClick={handleShowMore}>
                {hasMore ? 'More FAQs' : 'Less FAQs'}
            </button>
        </div>
    );
}
